import { FC, Fragment } from "react"
import { HeadingButtonProps } from "./models"
import { Button } from "../../../../../../_webui/layout/components/Button"
import { Translate } from "../../../../../../constant/Translate"

const { TEXT_T400 } = Translate

export const TravelerHeadingButton: FC<HeadingButtonProps> = ({
  goToSchedulesAddDraft,
  goToTravelersEditDraft,
  isHiddenBtnScheduleDraft,
  isHiddenBtnTravelerDraft,
  isPathnameTravelers,
  isPathnameTravelersUser,
}) => (
  <Fragment>
    {isPathnameTravelersUser ? (
      <Button
        isHidden={isHiddenBtnTravelerDraft}
        className="card-heading-button"
        htmlType="button"
        onClick={goToTravelersEditDraft}
        text={TEXT_T400}
        type="warning"
      />
    ) : (
      isPathnameTravelers && (
        <Button
          isHidden={isHiddenBtnScheduleDraft}
          className="card-heading-button"
          htmlType="button"
          onClick={goToSchedulesAddDraft}
          text={TEXT_T400}
          type="warning"
        />
      )
    )}
  </Fragment>
)
